<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <template v-if="count">
            <h1 ><span style="text-transform: capitalize">{{type}}</span> in {{vendor}}</h1>
            
            <template v-if="dataDetailMetrics.length > 0">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>No</th>
                  <th>Customer Name</th>
                  <th>Register Date</th>
                  <th>Installation Address</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, i) in dataDetailMetrics">
                  <td>{{i+1}}</td>
                  <td>{{data.cust_acc_name}}</td>
                  <td>{{data.cust_reg_date}}</td>
                  <td>{{data.installation_address}}</td>
                </tr>
                </tbody>
              </table>
            </template>
            <template v-else>
              <div class="alert alert-warning">
                No Data Customer
              </div>
            </template>
          </template>
          <template v-else>
            <h1>{{vendor}}</h1>
            <div>
              Type : {{type}} <br>
              Periode : {{periode}} <br>
              MTTR : {{meanTimetoRecover | convertSecond}}
            </div>
            <br>
            <br>
            <div class="table-responsive">
              <template v-if="type === 'ptp'">
                <ptp :dataDetailMetric="dataDetailMetrics" :totalDown="totalDown"></ptp>
              </template>
              <template v-else-if="type == 'fttx'">
                <fttx :dataDetailMetric="dataDetailMetrics" :totalDown="totalDown"></fttx>
              </template>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import {getService} from "../../../services";
  import Fttx from './detailMetric/Fttx'
  import Ptp from './detailMetric/Ptp'
  export default {
    components: {
      Fttx,
      Ptp
    },
    data() {
      return {
        vendor: '',
        periode: '',
        type: '',
        totalDown: 0,
        dataDetailMetrics: [],
        count: false,
        meanTimetoRecover: 0
      }
    },
    created: function () {
      let vendor, month, year, type, branch, mode
      branch = this.$route.query.branch
      vendor = this.$route.query.vendor
      month = this.$route.query.month
      year = this.$route.query.year
      type = this.$route.query.type
      mode = this.$route.query.mode
      if (mode == 0){
        this.count = false
        this.getDetailMetric(branch, vendor, year, month, type, mode)
      } else if(mode == 1) {
        this.count = true
        this.type = type
        this.getDetailMetric(branch, vendor, year, month, type, mode)
      }
    },
    methods: {
      getDetailMetric(branch, vendor, year, month, type, mode) {
        getService.list_metric_vendor_detail(branch, vendor, year, month, type, mode)
          .then(
            data => {
              let dataArrayMetric = []
              this.vendor = data.vendor_name
              if(mode == 0) {
                this.type = data.type
                this.periode = data.periode
                this.totalDown = data.total_down
                this.meanTimetoRecover = data.mttr
              }
              for (let i in data.data) {
                if (data.data.hasOwnProperty(i)) {
                  dataArrayMetric.push(data.data[i])
                }
              }
              this.dataDetailMetrics = dataArrayMetric
            }
          )
      }
    }
  }
</script>
<style>

</style>
